<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { capitalizeWords } from '@/common/textFormater';
import { getStopTime, getStopDay } from '@/utils/time';
import MyLoadsDesktopPaginationComponent from '@/components/myLoads/MyLoadsDesktopPaginationComponent.vue';
import TeleportModalWrapperComponent from '@/components/TeleportModalWrapperComponent.vue';
import { useRouter } from 'vue-router';
import CarrierWorkflowModalComponent from '@/components/modals/CarrierWorkflowModalComponent.vue';
import DisplayEquipmentTableModal from '@/components/modals/displayEquipmentTableModal.vue';
import { useScreenSize } from '@/composables/useScreenSize';
import { ButtonComponent } from '@/components';

const { innerHeight } = useScreenSize();
const router = useRouter();
const store = useStore();
// const getCityLength = (array, index = 'none') => {
//   if (index === 'none') {
//     return array.city ? array.city.length : 0;
//   }
//   if (array[index] && array[index].city) {
//     return array[index].city.length;
//   } else if (array[index] && array[index].area_five_zip_city) {
//     return array[index].area_five_zip_city.length;
//   }
//   return 0;
// };

const activePageTab = computed(
  () => router.currentRoute.value.query.tab || 'unassigned'
);
const loadsData = computed(
  () => store.state.myLoadsStore[activePageTab.value].loads
);
const pagination = computed(
  () => store.state.myLoadsStore[activePageTab.value].pagination
);

const getStatusClass = (status) => {
  switch (status) {
    case 'progress':
      return 'bg-ocean-100 text-ocean-800';
    case 'covered':
      return 'bg-sun-50 text-sun-800';
    case 'cancelled':
      return 'bg-steel-100 text-steel-800';
    case 'unassigned':
      return 'bg-rose-100 text-rose-800';
    default:
      return 'bg-forest-100 text-forest-800';
    //   default case is green/good
  }
};
const stopDetails = (stop) => {
  if (!stop) {
    return false;
  }
  return {
    id: stop.id,
    street1: capitalizeWords(stop.street1),
    street2: capitalizeWords(stop.street2),
    city: capitalizeWords(stop.city) || stop.area_five_zip_city || '',
    state: stop.state || stop.area_five_zip_state || '',
    zip: stop.postal_code || '',
    appointmentDay: getStopDay(
      stop.scheduled_window_started_at_in_stop_timezone ||
        stop.scheduled_window_ended_at_in_stop_timezone,
      stop.timezone,
      { monthNumeric: true, yearDigits: 2, includesYear: false }
    ),
    appointmentTime: getStopTime(
      stop.scheduled_window_started_at_in_stop_timezone ||
        stop.scheduled_window_ended_at_in_stop_timezone,
      stop.timezone
    ),
    stopDateRaw:
      stop.scheduled_window_started_at_in_stop_timezone ||
      stop.scheduled_window_ended_at_in_stop_timezone,
    timezone: stop.timezone,
    arrivalDay: getStopDay(stop.arrived_at_in_stop_timezone, stop.timezone),
    arrivalTime: getStopTime(stop.arrived_at_in_stop_timezone, stop.timezone),
    departureDay: getStopDay(stop.departed_at_in_stop_timezone, stop.timezone),
    departureTime: getStopTime(
      stop.departed_at_in_stop_timezone,
      stop.timezone
    ),
  };
};
// const handleOriginSort = () => {
//   const sortDirection = originSort.value === 'asc' ? 'desc' : 'asc';
//   router.push({
//     query: {
//       ...router.currentRoute.value.query,
//       sort: `origin_${sortDirection}`,
//     },
//   });
// };
// const handleDestinationSort = () => {
//   const sortDirection = destinationSort.value === 'asc' ? 'desc' : 'asc';
//   router.push({
//     query: {
//       ...router.currentRoute.value.query,
//       sort: `destination_${sortDirection}`,
//     },
//   });
// };
// const originSort = computed(() => {
//   const sortQuery = router.currentRoute.value.query?.sort;
//   const [key, value] = sortQuery?.split('_') || [];
//   if (key === 'origin') {
//     return value;
//   } else {
//     return 'desc';
//   }
// });
// const destinationSort = computed(() => {
//   const sortQuery = router.currentRoute.value.query?.sort;
//   const [key, value] = sortQuery?.split('_') || [];
//   if (key === 'destination') {
//     return value;
//   } else {
//     return 'desc';
//   }
// });
// const showEldStatus = ref(false);
const ids = computed(() =>
  loadsData.value.map((load) => ({
    internal: load.id,
    external: load.shipment_identifier,
  }))
);
const statuses = computed(() =>
  loadsData.value.map((load) => load.status.replace('_', ' '))
);
const origins = computed(() =>
  loadsData.value.map((load) =>
    load.stops?.length ? stopDetails(load.stops[0]) : { city: '-' }
  )
);
const destinations = computed(() =>
  loadsData.value.map((load) =>
    load.stops?.length > 0
      ? stopDetails(load.stops[load.stops.length - 1])
      : { city: '-' }
  )
);
// const truckNumbers = computed(() =>
//   loadsData.value.map((load) => load.carrier_vehicle?.truck_number || '-')
// );
// const vins = computed(() =>
//   loadsData.value.map((load) => load.carrier_vehicle?.vin || '-')
// );
const getTabTotalRecords = (tab) =>
  store.state.myLoadsStore[tab].pagination.totalRecords;
const hoverIndex = ref(null);
const totalRecords = computed(() => getTabTotalRecords(activePageTab.value));
const showAssignVehicleModal = ref(false);
// const isLoadingAssignedVehicle = ref(false);
const selectedLoad = ref({});

const selectedLoadOrigin = ref({});
const selectedLoadDestination = ref({});
const selectedLoadAssignedVehicle = computed(
  () =>
    selectedLoad.value.carrier_vehicle || {
      id: '',
      truck_number: '',
      vin: '',
    }
);
const selectedLoadPendingVehicle = computed(
  () =>
    selectedLoad.value.pending_driver_carrier_vehicle || {
      id: '',
      truck_number: '',
      vin: '',
    }
);

const selectedLoadTicketId = computed(
  () => selectedLoad.value.tickets?.[0]?.id || ''
);

const carrierVisibleTicketId = computed(
  () => selectedLoad.value.carrier_visible_tickets?.[0]?.id || ''
);

const showEquipmentModal = ref(false);

const onCloseEquipmentModal = () => {
  showEquipmentModal.value = false;
  showAssignVehicleModal.value = true;
};
</script>
<template>
  <div class="flex w-full flex-col">
    <!-- table -->
    <div
      class="border-1 scrollbar-thin relative h-[calc(100vh-320px)] max-w-full overflow-x-scroll overflow-y-scroll rounded-t-[5px] border border-b-0 border-neutral-300-a"
    >
      <div class="flex flex-1">
        <!-- table columns -->
        <!-- col 1 -->
        <div class="flex flex-1 flex-col lg:min-w-[300px]">
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 py-1.5 pl-3 pr-6 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            Load ID
          </div>
          <RouterLink
            v-for="(id, index) of ids"
            :key="id"
            :to="{
              name: 'Load Detail',
              params: { id: id.internal },
            }"
            class="flex h-14 min-w-fit items-center justify-start whitespace-normal break-words border-t border-neutral-300-a px-3 py-1.5 pl-3 pr-6 text-left text-xs font-normal leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                underline: index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = index"
            @mouseleave="hoverIndex = null"
          >
            {{ id.external || '-' }}
          </RouterLink>
        </div>
        <!-- col 2 -->
        <!-- no wrapping for status pills -->
        <div
          v-if="activePageTab !== 'unassigned'"
          class="flex min-w-fit flex-1 flex-col"
        >
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 py-1.5 pl-3 pr-6 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            Status
          </div>
          <RouterLink
            v-for="(status, index) of statuses"
            :key="index"
            :to="{
              name: 'Load Detail',
              params: { id: ids[index]?.internal },
            }"
            class="flex h-14 items-center justify-start border-t border-neutral-300-a py-1.5 pl-3 pr-6 text-xs font-normal capitalize leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = index"
            @mouseleave="hoverIndex = null"
          >
            <div
              class="flex items-center justify-center gap-1 rounded-full px-1.5 py-0.5"
              :class="getStatusClass(status)"
            >
              {{ status }}
            </div>
          </RouterLink>
        </div>
        <div class="flex flex-1 flex-col">
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 px-3 py-1.5 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            Origin
          </div>
          <RouterLink
            v-for="(origin, index) of origins"
            :key="index"
            :to="{
              name: 'Load Detail',
              params: { id: ids[index]?.internal },
            }"
            class="flex h-14 flex-col items-start justify-center gap-0.5 border-t border-neutral-300-a px-3 py-1.5 text-xs font-normal leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'border-t-0': index === 0,
                'bg-steel-200': index === hoverIndex,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = index"
            @mouseleave="hoverIndex = null"
          >
            <div
              v-if="origin.city"
              class="flex min-w-24 items-center justify-start text-steel-800"
            >
              {{
                `${origin.city}${origin.city === '-' ? '' : `, ${origin.state}`}`
              }}
            </div>
            <div
              v-if="origin.appointmentDay"
              class="flex min-w-24 items-center justify-start leading-3 text-steel-700"
            >
              {{
                `${origin.appointmentDay}${origin.appointmentTime ? ` • ${origin.appointmentTime}` : ''}`
              }}
            </div>
          </RouterLink>
        </div>
        <div class="flex flex-1 flex-col">
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 px-3 py-1.5 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            Destination
          </div>
          <RouterLink
            v-for="(destination, index) of destinations"
            :key="index"
            :to="{
              name: 'Load Detail',
              params: { id: ids[index]?.internal },
            }"
            class="flex h-14 flex-col items-start justify-center gap-0.5 border-t border-neutral-300-a px-3 py-1.5 text-xs font-normal leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = index"
            @mouseleave="hoverIndex = null"
          >
            <div
              v-if="destination.city"
              class="flex min-w-24 items-center justify-start text-steel-800"
            >
              {{
                `${destination.city}${destination.city === '-' ? '' : `, ${destination.state}`}`
              }}
            </div>
            <div
              v-if="destination.appointmentDay"
              class="flex min-w-24 items-center justify-start leading-3 text-steel-700"
            >
              {{
                `${destination.appointmentDay}${destination.appointmentTime ? ` • ${destination.appointmentTime}` : ''}`
              }}
            </div>
          </RouterLink>
        </div>
        <div
          v-if="activePageTab === 'unassigned'"
          class="flex min-w-fit flex-1 flex-col"
        >
          <div
            class="sticky top-0 flex h-12 items-center border-b bg-steel-100 py-1.5 pl-3 pr-6 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          ></div>
          <div
            v-for="(_, index) of loadsData"
            :key="index"
            class="flex h-14 flex-shrink-0 items-center justify-start border-t border-neutral-300-a py-1.5 pl-3 pr-6 text-xs font-normal capitalize leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = null"
            @mouseleave="hoverIndex = null"
          >
            <ButtonComponent
              :variant="
                loadsData[index]?.carrier_vehicle?.id
                  ? 'secondary'
                  : loadsData[index]?.pending_driver_carrier_vehicle?.id
                    ? 'default'
                    : 'primary'
              "
              class="text-xs"
              @click="
                (e) => {
                  e.stopPropagation();
                  showAssignVehicleModal = true;
                  selectedLoad = loadsData[index];
                  selectedLoadOrigin = origins[index];
                  selectedLoadDestination = destinations[index];
                }
              "
            >
              {{
                `${loadsData[index]?.carrier_vehicle?.id ? 'Confirm' : loadsData[index]?.pending_driver_carrier_vehicle?.id ? 'Change' : 'Assign'} Vehicle`
              }}
            </ButtonComponent>
            <!-- add status pills -->
          </div>
        </div>
        <!-- <div class="flex flex-1 flex-col">
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 px-3 py-1.5 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            Truck Number
          </div>
          <RouterLink
            v-for="(truckNumber, index) of truckNumbers"
            :key="index"
            :to="{
              name: 'Load Detail',
              params: { id: ids[index]?.internal },
            }"
            class="flex h-14 items-center justify-start border-t border-neutral-300-a px-3 py-1.5 text-xs font-normal leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = null"
          >
            {{ truckNumber || '-' }}
          </RouterLink>
        </div>
        <div class="flex flex-1 flex-col">
          <div
            class="sticky top-0 flex h-12 w-full items-center border-b bg-steel-100 px-3 py-1.5 text-sm font-medium leading-tight tracking-tight text-steel-1100"
          >
            VIN
          </div>
          <RouterLink
            v-for="(vin, index) of vins"
            :key="index"
            :to="{
              name: 'Load Detail',
              params: { id: ids[index]?.internal },
            }"
            class="flex h-14 items-center justify-start border-t border-neutral-300-a px-3 py-1.5 text-xs font-normal leading-none tracking-tight text-steel-800"
            :class="[
              {
                'pb-1': index !== loadsData?.length - 1,
                'bg-steel-200': index === hoverIndex,
                'border-t-0': index === 0,
                'border-b': index === ids.length - 1,
              },
            ]"
            @mouseover="hoverIndex = index"
            @mouseleave="hoverIndex = null"
          >
            {{ vin || '-' }}
          </RouterLink>
        </div> -->
      </div>
    </div>
    <div
      class="border-1 flex h-14 max-w-full items-center justify-between rounded-b-[5px] border border-t-0 border-neutral-300-a bg-white px-3 shadow-[0px_-1px_6px_0px_rgba(160,160,160,0.22)]"
    >
      <div
        class="text-xs font-medium leading-none tracking-tight text-steel-700"
      >
        Showing
        {{ loadsData.length > 0 ? (pagination.currentPage - 1) * 50 + 1 : 0 }} -
        {{ (pagination.currentPage - 1) * 50 + loadsData.length }} of
        {{ totalRecords }}
      </div>
      <MyLoadsDesktopPaginationComponent
        v-if="pagination.totalPages > 1"
        :current-page="pagination.currentPage"
        :total-pages="pagination.totalPages"
        :push-page-param-to-url="true"
        :alignment="'center'"
      />
      <div
        class="invisible text-xs font-medium leading-none tracking-tight text-steel-700"
      >
        50 results per page
      </div>
    </div>
    <TeleportModalWrapperComponent
      :margin-top="innerHeight < 700 ? 'mt-[60px]' : ''"
      :align="innerHeight < 700 ? 'start' : 'center'"
      :is-modal-open="showAssignVehicleModal"
    >
      <CarrierWorkflowModalComponent
        :load-id="selectedLoad.id"
        :external-load-id="selectedLoad.shipment_identifier"
        :load-ticket-id="selectedLoadTicketId || carrierVisibleTicketId || ''"
        :is-load-trackable="
          selectedLoad.billable_miles ? selectedLoad.billable_miles > 150 : true
        "
        :origin="selectedLoadOrigin"
        :destination="selectedLoadDestination"
        :assigned-vehicle="selectedLoadAssignedVehicle"
        :pending-vehicle="selectedLoadPendingVehicle"
        @close-modal="showAssignVehicleModal = false"
        @open-view-equipment-modal="
          () => {
            showAssignVehicleModal = false;
            showEquipmentModal = true;
          }
        "
      />
    </TeleportModalWrapperComponent>
    <Teleport to="body">
      <DisplayEquipmentTableModal
        :visible="showEquipmentModal"
        :show-dismiss-button-prop="true"
        @close="onCloseEquipmentModal"
      />
    </Teleport>
  </div>
</template>
<style scoped>
::-webkit-scrollbar {
  -webkit-appearance: none;
  height: 5px;
}
::-webkit-scrollbar-track {
  background-color: rgba(100, 100, 100, 0.5);
  border-radius: 5px;
}
/* yellow 248 198 23 */
/* gray  109, 113, 129 */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgb(109, 113, 129);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: #9ca3af transparent;
}
.action-column {
  width: 48px;
}
.desktop-container {
  width: 1920px;
}
.icon-flip {
  transform: scale(-1);
}
/* a[title] {
  position: relative;
} */
/* a[title]:hover::after {
  content: attr(title);
  display: inline-block;
  padding: 0.2em 0.6em;
  white-space: nowrap;
  font-size: 0.8em;
  background-color: gray;
  border-radius: 0.5rem;
  color: #fff;
  font-style: normal;
  font-family: sans-serif;
  font-size: 0.8em;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -1em);
  z-index: 1;
} */
</style>
